import "babel-polyfill";
import React, { Fragment, useState, useEffect } from "react";
import {
  Navbar,
  Nav,
  NavItem,
  MenuItem,
  NavDropdown,
  Modal,
  Button
} from "react-bootstrap";
// import logo from "images/wishCollectorLogoOfficial.png";
import logo from "images/aicomposz-logo-HighRes-White-Trans.png";
import AboutModal from "./AboutModal";
import PricingModal from "./PricingModal";

import profile from "images/blankProfile.png";

import FileManager from "./UserImgcredit/UserImgcredit";

function Mynavbar(user_id, user_name, has_view_products, imgCredits, mobile) {
  const [buyFlg, setBuyFlg] = useState(false);
  const [buyFlgMobile, setBuyFlgMobile] = useState(false);

  const handleBuyFlg = () => {
    setBuyFlg(true);
  };

  const handleBuyFlgMobile = () => {
    setBuyFlgMobile(true);
  };

  const [showPurchase, setShowPurchase] = useState(false);
  const [show3, setShow3] = useState(false);
  const showDropdown3 = (e) => {
    setShow3(true);
  };
  const hideDropdown3 = (e) => {
    setShow3(false);
  };

  const [show2, setShow2] = useState(false);
  const showDropdown2 = (e) => {
    setShow2(true);
  };
  const hideDropdown2 = (e) => {
    setShow2(false);
  };

  const [show1, setShow1] = useState(false);
  const showDropdown1 = (e) => {
    setShow1(true);
    setShow(false);
  };
  const hideDropdown1 = (e) => {
    setShow1(false);
  };

  const [show, setShow] = useState(false);
  const showDropdown = (e) => {
    setShow(true);
  };
  const hideDropdown = (e) => {
    setShow(false);
  };
  const toggleShow = (e) => {
    setShow(!show);
    setShow1(false);
    setShow2(false);
    setShow3(false);
  };
  const toggleShow1 = (e) => {
    setShow1(!show1);
    setShow(false);
    setShow2(false);
    setShow3(false);
  };
  const toggleShow2 = (e) => {
    setShow2(!show2);
    setShow(false);
    setShow1(false);
    setShow3(false);
  };
  const toggleShow3 = (e) => {
    setShow3(!show3);
    setShow(false);
    setShow1(false);
    setShow2(false);
  };

  const hideDD = (e) => {
    toggleShow();
    $("#responsive-navbar-nav").removeClass("navbar-collapse collapse in");
    $("#responsive-navbar-nav").addClass("navbar-collapse collapse");
    const el = document.getElementById("nav-toggle");
    el.click();
  };

  const hideDD1 = (e) => {
    toggleShow1();
    $("#responsive-navbar-nav").removeClass("navbar-collapse collapse in");
    $("#responsive-navbar-nav").addClass("navbar-collapse collapse");
    const el = document.getElementById("nav-toggle");
    el.click();
  };

  const handleToggle = (e) => {
    // do nothing
  };

  const [isAboutModalOpen, setIsAboutModalOpen] = useState(false);
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const countryCode = getCookie("countryCode");
  //    const countryCode = "US"

  return window.innerWidth > 450 ? (
    <React.Fragment>
      {buyFlg && <FileManager flg={buyFlg} setBuyFlg={setBuyFlg} />}
      <Navbar
        expand="lg"
        inverse
        collapseOnSelect
        style={{
          //   borderRadius: "0px",
          //   backgroundColor: "#000",
          //   color: "#fff",
          //   position: "sticky",
          //   minHeight: "55px",
          //   maxHeight: "55px",
          border: "none",
          backgroundColor: "#29335b"
        }}
        // variant="dark"
        // fixed="top"
        className="fixed top-0 w-full z-50 glass px-6 py-1  flex justify-between items-center"
      >
        <Navbar.Brand>
          {/* <a href="/" className="navbar-left"  ><img height="40px" src={logo} style={{paddingTop:"-7px"}}/></a> */}

          <a href="/" style={{ marginTop: "-18px" }}>
            <img height="60px" src={logo} />
          </a>
        </Navbar.Brand>
        {user_id != -1 ? (
          <Fragment>
            {/* <FileManager login="true"></FileManager> */}
            <Nav pullRight>
              <Button
                id="buyImgCredits"
                className="uppercase text-white/40 text-[10px] gap-2.5 "
                style={{
                  // backgroundColor: "rgb(230 51 147)",
                  backgroundColor: "#222542",
                  color: "white",
                  fontSize: mobile ? "10px" : "10px",
                  fontFamily: "Segouie",
                  // margin: this.state.mobile ? "20%" : "5%",
                  // marginLeft: mobile ? "48vw" : "23vw",
                  boxShadow: "2px 2px 2px rgba(46, 46, 46, 0.32)",
                  marginTop: mobile ? "6.5px" : "6.5px",
                  borderRadius: "15px",

                  border: "none",
                  width: "fit-content"
                }}
                // onClick={() => setshowModal(false)}
                // onClick={() => setShowPurchase(true)}
                onClick={handleBuyFlg}
              >
                <span>
                  Buy Image Credits <br></br>
                  {/* <br></br> */}
                  <span
                    style={{
                      color: imgCredits > 0 ? "#16ff00" : "red",
                      fontSize: "12px",
                      fontWeight: "bold",
                      textTransform: "capitalize"
                    }}
                  >
                    ( {imgCredits} available )
                  </span>
                </span>
              </Button>

              <Nav pullRight>
                {/* {user_id!=-1? */}

                {user_id === 1 ? (
                  <NavDropdown
                    eventKey={3}
                    style={{ marginTop: "5px" }}
                    title={<span style={{ color: "white" }}>Dashboard</span>}
                    id="3"
                    onClick={toggleShow2}
                    open={show2}
                    onToggle={handleToggle}
                    onMouseEnter={toggleShow2}
                    onMouseLeave={toggleShow2}
                  >
                    <div style={{ display: show2 ? "block" : "none" }}>
                      <MenuItem
                        eventKey={3.1}
                        href="/products"
                        style={{ backgroundColor: "#000000" }}
                      >
                        <span
                          style={{
                            padding: "5px",
                            color: "white",
                            fontWeight: "normal",
                            fontSize: "125%"
                          }}
                        >
                          My Products
                        </span>
                      </MenuItem>
                    </div>
                  </NavDropdown>
                ) : (
                  ""
                )}
                <NavDropdown
                  eventKey={2}
                  id="4"
                  title={
                    <img
                      height="20px"
                      src={profile}
                      style={{ marginTop: "-5px", paddingTop: "3px" }}
                    />
                  }
                  onMouseEnter={showDropdown3}
                  onMouseLeave={hideDropdown3}
                  open={show3}
                  style={{ paddingTop: "3px" }}
                  onToggle={handleToggle}
                >
                  <div style={{ display: show3 ? "block" : "none" }}>
                    <li className="dropdown-header">
                      <span
                        style={{
                          marginLeft: "-15px",
                          textAlign: "center",
                          color: "gray",
                          fontWeight: "normal",
                          fontSize: "125%"
                        }}
                      >
                        Logged in as:{" "}
                      </span>
                      <br></br>
                      <span
                        style={{
                          marginLeft: "-15px",
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                          fontSize: "125%"
                        }}
                      >
                        {user_name}
                      </span>
                    </li>
                    <MenuItem
                      eventKey={3.1}
                      href="/users/sign_out"
                      data-method="delete"
                      style={{ backgroundColor: "#ff0000" }}
                    >
                      <span
                        style={{
                          paddingLeft: "5px",
                          color: "white",
                          fontWeight: "normal",
                          fontSize: "125%"
                        }}
                      >
                        Log out
                      </span>
                    </MenuItem>
                  </div>
                </NavDropdown>
              </Nav>
            </Nav>
          </Fragment>
        ) : (
          <Navbar.Collapse>
            <Nav pullRight>
              <NavItem
                eventKey={0}
                onClick={(e) => {
                  e.preventDefault();
                  setIsAboutModalOpen(true);
                }}
              >
                About
              </NavItem>

              <NavItem
                eventKey={1}
                onClick={(e) => {
                  e.preventDefault();
                  setIsPricingModalOpen(true);
                }}
              >
                Pricing
              </NavItem>

              <NavItem eventKey={3} href="/users/sign_in">
                Login
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        )}
      </Navbar>

      <AboutModal
        isOpen={isAboutModalOpen}
        onClose={() => setIsAboutModalOpen(false)}
        mobile={mobile}
        countryCode={countryCode}
      />

      <PricingModal
        isOpen={isPricingModalOpen}
        onClose={() => setIsPricingModalOpen(false)}
        mobile={mobile}
        countryCode={countryCode}
      />
    </React.Fragment>
  ) : (
    // mobile below

    <React.Fragment>
      {buyFlgMobile && (
        <FileManager flg={buyFlgMobile} setBuyFlg={setBuyFlgMobile} />
      )}
      <Navbar
        collapseOnSelect
        className="fixed top-0 w-full z-50 glass px-16"
        style={{ border: "none", backgroundColor: "#29335b" }}
      >
        <div
          style={{
            paddingTop: "10px",
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
          }}
        >
          <a href="/" className="navbar-left">
            <img height="50px" src={logo} />
          </a>

          {user_id !== -1 ? (
            <Button
              id="buyImgCredits"
              className="uppercase text-white/40 text-[10px] gap-2.5"
              style={{
                backgroundColor: "#222542",
                color: "white",
                fontSize: mobile ? "10px" : "10px",
                fontFamily: "Segouie",
                // margin: this.state.mobile ? "20%" : "5%",
                // marginLeft: mobile ? "48vw" : "23vw",
                boxShadow: "2px 2px 2px rgba(46, 46, 46, 0.32)",
                marginTop: mobile ? "0px" : "6.5px",
                borderRadius: "15px",

                border: "none",
                width: "fit-content"
              }}
              // onClick={() => setshowModal(false)}
              // onClick={() => setShowPurchase(true)}
              onClick={handleBuyFlgMobile}
            >
              <span>
                Buy Image Credits <br></br>
                {/* <br></br> */}
                <span
                  style={{
                    color: imgCredits > 0 ? "#16ff00" : "red",
                    fontSize: "12px",
                    fontWeight: "bold",
                    textTransform: "capitalize"
                  }}
                >
                  ( {imgCredits} Available )
                </span>
              </span>
            </Button>
          ) : (
            ""
          )}
          <Navbar.Toggle
            id="nav-toggle"
            style={{
              backgroundColor: "#fff",
              height: "25px",
              paddingTop: "6px",
              marginTop: "7px"
            }}
          />
        </div>
        {/* {user_id !== -1 ? <FileManager login="false"></FileManager> : ""} */}

        <div
          style={{
            position: "absolute",
            right: "1px",
            zIndex: "1000",
            width: "40vw"
          }}
        >
          <Navbar.Collapse
            id="responsive-navbar-nav"
            style={{ backgroundColor: "#2c354f" }}
          >
            {user_id != -1 ? (
              <Nav pullRight>
                {/* {user_id!=-1? */}
                {user_id === 1 ? (
                  <Fragment>
                    <NavDropdown
                      className="dropdown open"
                      eventKey={3}
                      style={{
                        borderBottom: "solid 1px white",
                        marginTop: "5px"
                      }}
                      title={<span style={{ color: "white" }}>Dashboard</span>}
                      id="3"
                      onClick={toggleShow2}
                      open={show2}
                      onToggle={handleToggle}
                    >
                      <div style={{ display: show2 ? "block" : "none" }}>
                        <MenuItem
                          eventKey={3.1}
                          href="/products"
                          style={{ backgroundColor: "#000000" }}
                        >
                          <span
                            style={{
                              padding: "5px",
                              color: "white",
                              fontWeight: "normal",
                              fontSize: "125%"
                            }}
                          >
                            My Products
                          </span>
                        </MenuItem>
                      </div>
                    </NavDropdown>
                  </Fragment>
                ) : (
                  ""
                )}

                <NavDropdown
                  className="dropdown open"
                  eventKey={2}
                  id="4"
                  title={<img height="20px" src={profile} />}
                  onClick={toggleShow3}
                  open={show3}
                  onToggle={handleToggle}
                  onMouseEnter={toggleShow3}
                  onMouseLeave={toggleShow3}
                >
                  <div style={{ display: show3 ? "block" : "none" }}>
                    <li className="dropdown-header">
                      <span
                        style={{
                          marginLeft: "-20px",
                          textAlign: "center",
                          color: "yellow",
                          fontWeight: "normal",
                          fontSize: "125%"
                        }}
                      >
                        Logged in as:{" "}
                      </span>
                      <br></br>
                      <span
                        style={{
                          marginLeft: "-20px",
                          textAlign: "center",
                          color: "white",
                          fontWeight: "bold",
                          fontSize: "125%"
                        }}
                      >
                        {user_name}
                      </span>
                    </li>
                    <MenuItem
                      eventKey={3.1}
                      href="/users/sign_out"
                      data-method="delete"
                      style={{ backgroundColor: "#ff0000" }}
                    >
                      <span
                        style={{
                          paddingLeft: "5px",
                          color: "white",
                          fontWeight: "normal",
                          fontSize: "125%"
                        }}
                      >
                        Log out
                      </span>
                    </MenuItem>
                  </div>
                </NavDropdown>
              </Nav>
            ) : (
              <Nav>
                <NavItem
                  eventKey={1}
                  onClick={(e) => {
                    e.preventDefault();
                    setIsAboutModalOpen(true);
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      marginLeft: "5px",
                      marginRight: "5px"
                    }}
                  >
                    About
                  </span>
                </NavItem>
                <NavItem
                  divider="true"
                  style={{ backgroundColor: "white", height: "1px" }}
                />
                <NavItem
                  eventKey={1}
                  onClick={(e) => {
                    e.preventDefault();
                    setIsPricingModalOpen(true);
                  }}
                  style={{ color: "white" }}
                >
                  <span style={{ color: "white" }}>Pricing</span>
                </NavItem>
                <NavItem
                  divider="true"
                  style={{ backgroundColor: "white", height: "1px" }}
                />
                <NavItem href="/users/sign_in">
                  <span style={{ color: "white", marginLeft: "5px" }}>
                    Login
                  </span>
                </NavItem>
              </Nav>
            )}
          </Navbar.Collapse>
        </div>
      </Navbar>

      <AboutModal
        isOpen={isAboutModalOpen}
        onClose={() => setIsAboutModalOpen(false)}
        mobile={mobile}
        countryCode={countryCode}
      />

      <PricingModal
        isOpen={isPricingModalOpen}
        onClose={() => setIsPricingModalOpen(false)}
        mobile={mobile}
        countryCode={countryCode}
      />
    </React.Fragment>
  );
}

export default Mynavbar;
